import React, { ReactNode } from 'react';
import { View } from 'react-native';

export function FormButtons(props: { children: ReactNode }) {
  return <View style={{ flex: 0, width: '95%', alignSelf: 'center' }}>{props.children}</View>;
}
